import styled from "styled-components";

export const Value = styled.span`
    margin-top: 10px;
    display: block;
`;
